import type { NewsItem as INewsItem } from '@cocoonspace/sdk-js/types/newsItem'
import { Alert, AlertIcon, AlertTitle } from '~/components/ui/alert'
import { cn } from '~/lib/utils'

export const NewsItem = ({ newsItem }: { newsItem: INewsItem }) => (
	<Alert variant={newsItem.type === 'bad' ? 'destructive' : 'default'}>
		<AlertIcon type={newsItem.type} />
		<AlertTitle className='mb-0 flex-1'>{newsItem.text}</AlertTitle>
	</Alert>
)

export const NewsList = ({
	news,
	className,
}: {
	news?: INewsItem[]
	className?: string
}) => {
	if (!news?.length) return null

	return (
		<div className={cn('flex flex-col gap-2', className)}>
			{news.map((newsItem, i) => (
				<NewsItem
					key={i}
					newsItem={newsItem}
				/>
			))}
		</div>
	)
}
